export default [
  {
    path: 'post/:id',
    name: 'post-front-view',
    component: () => import('@/views/pages/post/View.vue'),
    meta: {
      pageTitle: 'View',
      breadcrumb: [
        {
          to: { name: 'post-front' },
          text: 'Posts',
          active: false,
        },
        {
          text: 'View',
          active: true,
        },
      ],
      page: 'front',
    },
  },
]
